/**
 * Site wide initialization functions.
 * @file
 */

import Menubar from "@external/w3.org_menubar_example/MenubarLinks.js";


/* search box javascript */
export function InitializeSearch() {
   $('.searchBox').alphanumeric({ allow: "., " });

  $('.searchLink').keypress(function (e) {
    if (e.which === 13) {
      openSearchForm();
      $('.searchBox').focus();
    }
  });

  $('.searchIcon').on('click', function (e) {
    openSearchForm();
    $('.searchBox').focus();
  });


   // search remove icon is clicked so close search form
   $('.searchRemoveIcon').keypress(function (e) {
      closeSearchForm();
      $('.searchLink').focus();
   });
   $('.searchRemoveIcon').on('click', function (e) {
      closeSearchForm();
      $('.searchLink').focus();
   });

   // nav header is clicked so toggle it.  close the search form also.
   $('.header-nav').on('click', function () {
      $('nav.header ul').toggleClass('open');
      $('.searchform').removeClass('open');
      $('.homepage-banner').removeClass('searchOpen');
      $('.main-content').removeClass('searchOpen');
      $('.searchLink').removeClass('hide');
      $('.searchLink').toggleClass('navOpen');
   });
   
   // logged in nav is clicked so close the search form
   $('ul[role="menubar"] a[role="menuitem"]').on('click', function () {
      $('.searchform').removeClass('open');
      $('.main-content').removeClass('searchOpen');
      $('.searchLink').removeClass('hide');
      $('.searchLink').toggleClass('navOpen');
   });
}

export function InitializeNavBar() {
  var menubarId = $('.nav-list');
  if (menubarId.length > 0) {
    var menubar = new Menubar(menubarId[0]);
    menubar.init();
  }

    // If a link has a dropdown, add sub menu toggle.
    $('nav.loggedInNav ul li a.nav-dropdown-link.level1').click(function (e) {
        $(this).siblings('.nav-dropdown.level1').toggle();
        // Close one dropdown when selecting another
        $('.nav-dropdown.level1').not($(this).siblings()).hide();
        e.stopPropagation();
    });

    // Clicking away from dropdown will remove the dropdown class
    $('html').click(function () {
        $('.nav-dropdown').hide();
    });



    // Toggle open and close nav styles on click
    $('#nav-toggle').click(function () {
        $('nav.loggedInNav ul').slideToggle();
    });
    // Hamburger to X toggle
    $('#nav-toggle').on('click', function () {
        this.classList.toggle('active');

       if ($(this).hasClass('active')) {
          $('.searchform').removeClass('open');
          $('.searchLink').removeClass('hide');
       }
    });

   // Mac/Apple nav bar fix
   ApplyMacAppleCSSFixes();
}

function openSearchForm() {
   var $searchform = $('.searchform');
   var $navHeader = $('nav.header');

   if (!$searchform.hasClass('open')) {
      // search form is closed so open it and close the header nav
      $searchform.addClass('open');
      $navHeader.addClass('open');
      $('nav.header ul').removeClass('open');
      $('.homepage-banner').addClass('searchOpen');
      $('.main-content').addClass('searchOpen');
      $('.searchLink').addClass('hide');
      $('.searchLink').removeClass('navOpen');


      if ($('#nav-toggle').hasClass('active')) {
         $('nav.loggedInNav ul').slideToggle();
         $('#nav-toggle').removeClass('active');
      }

   }

}

function closeSearchForm() {
   $('.searchform').removeClass('open');
   $('nav.header').removeClass('open');
   $('.homepage-banner').removeClass('searchOpen');
   $('.main-content').removeClass('searchOpen');
   $('.searchLink').removeClass('hide');
   $('.searchLink').removeClass('navOpen');
}

function ApplyMacAppleCSSFixes() {
   var userAgent = "User agent: " + navigator.userAgent;
   if ((userAgent.indexOf("Macintosh") != -1) ||
      (userAgent.indexOf("PPC Mac") != -1) ||
      (userAgent.indexOf("iPad") != -1)) {

      $('ul.nav-list').each(function (x) {
         $(this).addClass("MacApple");
      });

      $('.header-navigation-inner').addClass("MacApple");
   }

}
